import React from 'react';
import Flexbox from 'flexbox-react';
import { Button, Dialog, Intent, Switch, HTMLSelect, Label } from '@blueprintjs/core';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import Utilities from '../../utils/Utilities';
import { CSVLink, CSVDownload } from 'react-csv';
import _ from 'lodash';

@inject('OrganizationStore', 'CurrentUserStore', 'ToastStore')
@observer
export default class OrganizationNewRelationship extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isBlurred: [],
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    this.toggleSubmitting();
    this.setState({ isBlurred: [] });
    this.props.OrganizationStore.createRelationship()
      .then(() => {
        this.toggleSubmitting();
        this.props.toggleDialog();
        this.props.OrganizationStore.setActiveTab('individual');
        this.props.ToastStore.showToast(I18n.t('js.relationship_created'), 'success');
      })
      .catch(() => {
        this.toggleSubmitting();
      });
  }

  toggleSubmitting() {
    this.setState({ isSubmitting: !this.state.isSubmitting });
  }

  handleInputChange(e) {
    this.props.OrganizationStore.updateNewRelationship(e.target.value, e.target.name);
  }

  handleBlurChange(e) {
    if (!_.includes(this.state.isBlurred, e.target.name)) {
      const newBlurState = this.state.isBlurred;
      newBlurState.push(e.target.name);
      this.setState({ isBlurred: newBlurState });
    }
  }

  handleDefaultChange() {
    this.props.OrganizationStore.newRelationship.defaultRelationship = !this.props.OrganizationStore.newRelationship.defaultRelationship;
  }

  handleLockUserChange() {
    this.props.OrganizationStore.newRelationship.lockUserChanges = !this.props.OrganizationStore.newRelationship.lockUserChanges;
  }

  handleLockCounterpartUserChange() {
    this.props.OrganizationStore.newRelationship.lockCounterpartUserChanges = !this.props.OrganizationStore.newRelationship
      .lockCounterpartUserChanges;
  }

  renderErrors(field) {
    if (_.includes(this.state.isBlurred, field) && !this.props.OrganizationStore.newRelationship[`${field}Valid`]) {
      return <div className="bp3-form-helper-text">{this.props.OrganizationStore.newRelationship[`${field}Error`]}</div>;
    }
    return undefined;
  }

  render() {
    return (
      <Dialog
        icon="add"
        isOpen={this.props.isOpen}
        onClose={() => this.props.toggleDialog()}
        canOutsideClickClose={false}
        portalContainer={document.body}
        inline={true}
        title={I18n.t('js.create_new_relationship')}
      >
        <form onSubmit={this.handleSubmit.bind(this)}>
          <div className="bp3-dialog-body">
            <Flexbox flexDirection="column">
              <p>{I18n.t('js.create_a_new_relationship_decsription')}</p>
            </Flexbox>
            <Flexbox flexDirection="column">
              <div
                className={
                  _.includes(this.state.isBlurred, 'name') && !this.props.OrganizationStore.newRelationship.nameValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="name">
                  {I18n.t('js.relationship_name')}
                  <span className="bp3-text-muted push-5-l">({I18n.t('js.required')})</span>
                  <div className="bp3-form-content">
                    <div
                      className={
                        _.includes(this.state.isBlurred, 'name') && !this.props.OrganizationStore.newRelationship.nameValid
                          ? classNames('bp3-input-group bp3-intent-danger')
                          : classNames('bp3-input-group')
                      }
                    >
                      <input
                        autoComplete="off"
                        className="bp3-input bp3-fill"
                        type="text"
                        placeholder={I18n.t('js.manager')}
                        name="name"
                        value={this.props.OrganizationStore.newRelationship.name}
                        onChange={this.handleInputChange.bind(this)}
                        onBlur={this.handleBlurChange.bind(this)}
                        dir="auto"
                      />
                    </div>
                    {this.renderErrors('name')}
                  </div>
                </label>
              </div>
            </Flexbox>
            <Flexbox flexDirection="column">
              <div
                className={
                  _.includes(this.state.isBlurred, 'counterpartName') && !this.props.OrganizationStore.newRelationship.counterpartNameValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="counterpartName">
                  {I18n.t('js.counterpart_name')}
                  <span className="bp3-text-muted push-5-l">({I18n.t('js.required')})</span>
                  <div className="bp3-form-content">
                    <div
                      className={
                        _.includes(this.state.isBlurred, 'counterpartName') &&
                        !this.props.OrganizationStore.newRelationship.counterpartNameValid
                          ? classNames('bp3-input-group bp3-intent-danger')
                          : classNames('bp3-input-group')
                      }
                    >
                      <input
                        autoComplete="off"
                        className="bp3-input bp3-fill"
                        type="text"
                        placeholder={I18n.t('js.direct_reports')}
                        name="counterpartName"
                        value={this.props.OrganizationStore.newRelationship.counterpartName}
                        onChange={this.handleInputChange.bind(this)}
                        onBlur={this.handleBlurChange.bind(this)}
                        dir="auto"
                      />
                    </div>
                    {this.renderErrors('counterpartName')}
                  </div>
                </label>
              </div>
            </Flexbox>
            <Flexbox flexDirection="column">
              <div
                className={
                  _.includes(this.state.isBlurred, 'description') && !this.props.OrganizationStore.newRelationship.descriptionValid
                    ? classNames('bp3-form-group bp3-intent-danger')
                    : classNames('bp3-form-group')
                }
              >
                <label className="bp3-label" htmlFor="description">
                  {I18n.t('js.relationship_description')}
                  <span className="bp3-text-muted push-5-l">({I18n.t('js.required')})</span>
                  <div className="bp3-form-content">
                    <div
                      className={
                        _.includes(this.state.isBlurred, 'description') && !this.props.OrganizationStore.newRelationship.descriptionValid
                          ? classNames('bp3-input-group bp3-intent-danger')
                          : classNames('bp3-input-group')
                      }
                    >
                      <textarea
                        className="bp3-input bp3-textarea bp3-fill"
                        type="textarea"
                        placeholder={I18n.t('js.manager_description')}
                        name="description"
                        value={this.props.OrganizationStore.newRelationship.description}
                        onChange={this.handleInputChange.bind(this)}
                        onBlur={this.handleBlurChange.bind(this)}
                        dir="auto"
                      />
                    </div>
                    {this.renderErrors('description')}
                  </div>
                </label>
              </div>
            </Flexbox>
            <Flexbox flexGrow={0}>
              <Switch
                disabled={this.props.OrganizationStore.relationships.length <= 1}
                className="bp3-control-no-margin"
                checked={this.props.OrganizationStore.newRelationship.defaultRelationship}
                label={I18n.t('js.default_relationship')}
                onChange={this.handleDefaultChange.bind(this)}
              />
            </Flexbox>
            <Flexbox flexGrow={0} flexDirection="column">
              <h4>{I18n.t('js.lock_relationship_changes')}</h4>
              <label className="bp3-label" htmlFor="description">
                {I18n.t('js.relationship_locking_description')}
                <div className="bp3-form-content">
                  <Switch
                    className="bp3-control-no-margin push-20-t"
                    checked={this.props.OrganizationStore.newRelationship.lockUserChanges}
                    label={I18n.t('js.lock_name_changes', { name: this.props.OrganizationStore.newRelationship.counterpartName })}
                    onChange={this.handleLockUserChange.bind(this)}
                  />
                </div>
                <div className="bp3-form-content">
                  <Switch
                    className="bp3-control-no-margin push-10-t"
                    checked={this.props.OrganizationStore.newRelationship.lockCounterpartUserChanges}
                    label={I18n.t('js.lock_name_changes', { name: this.props.OrganizationStore.newRelationship.name })}
                    onChange={this.handleLockCounterpartUserChange.bind(this)}
                  />
                </div>
              </label>
            </Flexbox>
          </div>
          <div className="bp3-dialog-footer">
            <div className="bp3-dialog-footer-actions">
              <Button text={I18n.t('js.cancel')} onClick={() => this.props.toggleDialog()} />
              <Button
                intent={Intent.PRIMARY}
                type="submit"
                disabled={!this.props.OrganizationStore.newRelationshipFormValid}
                text={I18n.t('js.create_new_relationship')}
                loading={this.state.isSubmitting}
              />
            </div>
          </div>
        </form>
      </Dialog>
    );
  }
}
